import React, { Component } from 'react'
import '../styles/ThemePickerItem.css'

class ThemePickerItem extends Component {

  isSelected = () => {
    return this.props.id === this.props.selected
  }

  render() {

    const selectedStyle = this.props.id === this.props.selected
      ? "theme-picker-item--selected"
      : ""

    return (
      <li
        className={`theme-picker-item ${selectedStyle}`}
        onClick={this.props.handleClick}
        >
        {
          this.props.singleTheme
          ?
            <div
            className={this.isSelected() ? "theme-picker-icon" : "theme-picker-icon theme-picker-icon--disabled"}
            style={{backgroundImage: `url(${this.props.icon})`}}>
            </div>
          : null
        }
        <span>{this.props.title}</span>
      </li>
    )
  }
}

export default ThemePickerItem



// WEBPACK FOOTER //
// ./src/components/ThemePickerItem.js